/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface BillingTablePartitionPostSpec { 
    /**
     * The year for which partitions are to be created
     */
    partition_year?: string;
    /**
     * The table for which partitions are to be created
     */
    table_name?: string;
}

